export const VERIFY_EMAIL_ERROR = "verify_email_error";
export const VERIFY_EMAIL_SUCCESS = "verify_email_success";

export const GET_VALUES = "get_values";
export const CLEAR_VALUES = "clear_values";

export const REPLY_MESSAGE = "reply_message";

export const FETCH_CONVERSATIONS_SUCCESS = "fetch_conversations_success";
export const FETCH_CONVERSATIONS_ERROR = "fetch_conversations_error";
export const CONVERSATIONS_UPDATE = "conversations_update";
export const CONVERSATIONS_DELETE = "conversations_delete";
export const CONVERSATIONS_EMPLOYEE_CONTACT_UPDATE = "conversation_employee_contact_update";
export const CONVERSATIONS_EMPLOYEE_BAN_UPDATE = "conversation_employee_ban_update";
export const CONVERSATIONS_EMPLOYEE_BAN = "conversation_employee_ban";
export const CONVERSATIONS_EMPLOYEE_UNBAN = "conversation_employee_unban";
export const CONVERSATIONS_ITEM_ACCEPT = "conversation_item_accept";
export const CONVERSATIONS_ITEM_COMPLETE = "conversation_item_complete";
export const CONVERSATIONS_ITEM_REJECT = "conversation_item_reject";
export const CONVERSATIONS_ITEM_SEEN = "conversation_item_seen";
export const CONVERSATIONS_ITEM_NOT_SEEN = "conversation_item_not_seen";

export const ENABLED_NOTIFICATIONS = "enabled_notification";
export const NEW_NOTIFICATION = "new_notification";
export const REMOVE_NOTIFICATION = "remove_notification";

export const FETCH_CONTACTS = "fetch_contacts";
export const DELETE_CONTACT = "delete_contact";
export const ADD_CONTACT = "add_contact";
export const TOGGLE_BAN_CONTACT = "toggle_ban_contact";
export const UPDATE_CONTACT = "update_contact";

export const SET_LANG = "set_lang";
